module.exports = __webpack_public_path__ + "static/media/Outdoor4.76323475.jpg";